"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isStatic;
function isStatic(opt) {
  return opt === null || opt && opt.static === true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-input-enhancements/lib/utils/isStatic.js
// module id = 64
// module chunks = 0